import React from 'react';
import './ValuesSection.css';

const ValuesSection: React.FC = () => {
  const values = [
    {
      icon: '🌍',
      title: 'Global Accessibility',
      description: 'Making financial services accessible to everyone, regardless of location or background.'
    },
    {
      icon: '🔒',
      title: 'Security First',
      description: 'Implementing the highest security standards to protect our users\' assets and data.'
    },
    {
      icon: '⚡',
      title: 'Innovation',
      description: 'Continuously pushing the boundaries of what\'s possible in financial technology.'
    },
    {
      icon: '🤝',
      title: 'Transparency',
      description: 'Building trust through open communication and transparent business practices.'
    },
    {
      icon: '💰',
      title: 'Affordability',
      description: 'Providing cost-effective solutions that don\'t compromise on quality or reliability.'
    },
    {
      icon: '🚀',
      title: 'Excellence',
      description: 'Striving for excellence in everything we do, from product development to customer service.'
    }
  ];

  return (
    <section className="values-section">
      <div className="container">
        <div className="section-title">
          <h2>Our Values</h2>
          <p>The principles that guide everything we do</p>
        </div>
        <div className="values-grid">
          {values.map((value, index) => (
            <div key={index} className="value-card">
              <div className="value-icon">{value.icon}</div>
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;
